export default {
    "Subtitles": "Subtitles",
    "Please select a .vtt file": "Please select a .vtt file",
    "Replace": "Replace",
    "Loading subtitles...": "Loading subtitles...",
    "No subtitles for this file": "No subtitles for this file",
    "Add a language": "Add a language",
    "Add subtitles": "Add subtitles",
    "Error adding subtitles": "Error adding subtitles",
    "Add": "Add",
    "Delete": "Delete",
    "Cancel": "Cancel",
    "WebVTT (.vtt) files only. Other formats such as SRT are not supported.": "WebVTT (.vtt) files only. Other formats such as SRT are not supported.",
    "Download": "Download",
    "Import a .vtt file": "Import a .vtt file",
    "Importing...": "Importing...",
    "Drop the .vtt file to replace these subtitles": "Drop the .vtt file to replace these subtitles",
    "{0} subtitles": "{0} subtitles",
    "Empty": "Empty",
    "Subtitles imported ({0})": "Subtitles imported ({0})",
    "Error uploading file: {0}": "Error uploading file: {0}",
    "Delete subtitles for this language?": "Delete subtitles for this language?",
    "Error adding language": "Error adding language",
    "Error deleting language": "Error deleting language",
    "ace": "Acehnese",
    "af": "Afrikaans",
    "sq": "Albanian",
    "am": "Amharic",
    "ar": "Arabic",
    "an": "Aragonese",
    "hy": "Armenian",
    "as": "Assamese",
    "ay": "Aymara",
    "az": "Azerbaijani",
    "ba": "Bashkir",
    "eu": "Basque",
    "be": "Belarusian",
    "bn": "Bengali",
    "bho": "Bhojpuri",
    "bs": "Bosnian",
    "br": "Breton",
    "bg": "Bulgarian",
    "yue": "Cantonese",
    "ca": "Catalan",
    "ceb": "Cebuano",
    "zh": "Chinese",
    "zh-hans": "Chinese (simplified)",
    "zh-hant": "Chinese (traditional)",
    "hr": "Croatian",
    "cs": "Czech",
    "da": "Danish",
    "prs": "Dari",
    "nl": "Dutch",
    "en": "English",
    "en-gb": "English (British)",
    "en-us": "English (American)",
    "eo": "Esperanto",
    "et": "Estonian",
    "fo": "Faroese",
    "fi": "Finnish",
    "fr": "French",
    "fr-ca": "French (Canadian)",
    "fr-fr": "French (France)",
    "gl": "Galician",
    "ka": "Georgian",
    "de": "German",
    "de-de": "German (Germany)",
    "de-ch": "German (Swiss)",
    "el": "Greek",
    "gn": "Guarani",
    "gu": "Gujarati",
    "ht": "Haitian Creole",
    "ha": "Hausa",
    "haw": "Hawaiian",
    "he": "Hebrew",
    "hi": "Hindi",
    "hu": "Hungarian",
    "is": "Icelandic",
    "ig": "Igbo",
    "id": "Indonesian",
    "ga": "Irish",
    "it": "Italian",
    "ja": "Japanese",
    "jw": "Javanese",
    "jv": "Javanese",
    "kn": "Kannada",
    "pam": "Kapampangan",
    "kk": "Kazakh",
    "km": "Khmer",
    "gom": "Konkani",
    "ko": "Korean",
    "ckb": "Kurdish (Sorani)",
    "kmr": "Kurdish (Kurmanji)",
    "ky": "Kyrgyz",
    "lo": "Lao",
    "la": "Latin",
    "lv": "Latvian",
    "ln": "Lingala",
    "lt": "Lithuanian",
    "lmo": "Lombard",
    "lb": "Luxembourgish",
    "mk": "Macedonian",
    "mg": "Malagasy",
    "mai": "Maithili",
    "ms": "Malay",
    "ml": "Malayalam",
    "mt": "Maltese",
    "mi": "Maori",
    "mr": "Marathi",
    "mn": "Mongolian",
    "my": "Myanmar",
    "ne": "Nepali",
    "no": "Norwegian",
    "nb": "Norwegian (bokmål)",
    "nn": "Nynorsk",
    "oc": "Occitan",
    "om": "Oromo",
    "pag": "Pangasinan",
    "ps": "Pashto",
    "fa": "Persian",
    "pl": "Polish",
    "pt": "Portuguese",
    "pt-br": "Portuguese (Brazilian)",
    "pt-pt": "Portuguese (European)",
    "pa": "Punjabi",
    "qu": "Quechua",
    "ro": "Romanian",
    "ru": "Russian",
    "sa": "Sanskrit",
    "sr": "Serbian",
    "st": "Sesotho",
    "sn": "Shona",
    "scn": "Sicilian",
    "sd": "Sindhi",
    "si": "Sinhala",
    "sk": "Slovak",
    "sl": "Slovenian",
    "so": "Somali",
    "es": "Spanish",
    "es-419": "Spanish (Latin American)",
    "su": "Sundanese",
    "sw": "Swahili",
    "sv": "Swedish",
    "tl": "Tagalog",
    "tg": "Tajik",
    "ta": "Tamil",
    "tt": "Tatar",
    "te": "Telugu",
    "th": "Thai",
    "bo": "Tibetan",
    "ts": "Tsonga",
    "tn": "Tswana",
    "tr": "Turkish",
    "tk": "Turkmen",
    "uk": "Ukrainian",
    "ur": "Urdu",
    "uz": "Uzbek",
    "vi": "Vietnamese",
    "cy": "Welsh",
    "wo": "Wolof",
    "xh": "Xhosa",
    "yi": "Yiddish",
    "yo": "Yoruba",
    "zu": "Zulu"
}
